import { render, staticRenderFns } from "./rmenu.vue?vue&type=template&id=0ed2fe8c&"
import script from "./rmenu.vue?vue&type=script&lang=js&"
export * from "./rmenu.vue?vue&type=script&lang=js&"
import style0 from "./rmenu.vue?vue&type=style&index=0&id=0ed2fe8c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports